import React from 'react';

interface FormProgressBarProps {
  current: number;
  total: number;
  primaryColor: string;
}

export const FormProgressBar: React.FC<FormProgressBarProps> = ({ current, total, primaryColor }) => {
  const progress = Math.min(99, ((current + 1) / total) * 100);

  return (
    <div className="mt-6 pt-6 border-t border-gray-200/50" data-testid="form-progress-bar">
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm font-medium text-gray-700">
          Step {current + 1} of {total}
        </span>
        <span className="text-sm text-gray-500">
          {Math.round(progress)}% Complete
        </span>
      </div>
      <div className="w-full bg-gray-200/70 rounded-full h-2.5">
        <div
          className="h-2.5 rounded-full transition-all duration-300"
          style={{
            backgroundColor: primaryColor,
            width: `${progress}%`,
            minWidth: '0.5rem'
          }}
        />
      </div>
    </div>
  );
};